import { Component, input, output } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

import { UiPalette } from '../../../types/UiPalette.type';

@Component({
  selector: 'eiq-icon-button',
  templateUrl: 'icon-button.component.html',
  styleUrls: ['./icon-button.component.scss']
})
export class IconButtonComponent {
  color = input<UiPalette>('primary');
  disabled = input<boolean>(false);
  icon = input<IconDefinition>();
  loading = input<boolean>(false);
  size = input<'extra-large' | 'large' | 'medium' | 'small' | 'tiny'>('medium');
  style = input<'basic' | 'stroked' | 'flat'>('basic');
  testId = input<string>();
  tooltip = input<string>();

  clicked = output<void>();
}
